<script setup lang="ts">
const { expanded = false } = defineProps<{
  expanded?: boolean;
}>();

const classObject = computed(() => ({
  "is-expanded": expanded,
}));
</script>

<template>
  <div class="widget-panel" :class="classObject">
    <slot></slot>
    <div id="modal"></div>
  </div>
</template>

<style lang="scss" scoped>
.widget-panel {
  position: fixed;
  right: 20px;

  bottom: 20px;

  display: flex;
  flex-direction: column;

  width: 380px;

  max-width: calc(100% - 40px);
  height: 640px;
  max-height: calc(100% - 40px);

  box-shadow: 0px 10px 30px 0 rgba(0, 0, 0, 0.3);
  border-radius: 10px;

  overflow: hidden;

  transition: all 800ms ease;

  &.is-expanded {
    width: 1000px;
    height: 1000px;
  }
}

@media only screen and (max-width: 420px) {
  .widget-panel {
    right: 0;
    bottom: 0;
    width: 100vh;
    width: 100dvh;
    max-width: 100%;
    height: 100vh;
    height: 100dvh;
    max-height: 100%;
    border-radius: 0;
  }
}
</style>
